export function getBoolean(value: string | number | boolean | undefined | null | object): boolean {
  if (value === null || value === undefined) {
    return false
  }
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    return value.trim().toLowerCase() === 'true' || value !== '0'
  }
  if (typeof value === 'object') {
    return true
  }
  return value !== 0
}

export function isTrue(value: string | number | boolean | undefined | null | object): boolean {
  return getBoolean(value)
}
